import module from 'module';
import _ from 'lodash';

class RedFlagAlertNotificationService {
  constructor($rootScope, http, systemPropertyCache) {
    this.$rootScope = $rootScope;
    this.http = http;
    this.systemPropertyCache = systemPropertyCache;
    
    this.systemAlertsEnabled = null;
    this.isRunning = false;
  }

  async fetchNotifications() {
    if (!(await this.isSystemAlertsEnabled()) || this.isRunning) {
      return;
    }

    try {
      this.isRunning = true;
      this.redFlagAlertNotifications = await this.http.get('/management/red-flag-notification', {nxLoaderSkip: true}).toPromise();
      this.$rootScope.$broadcast('redFlagNotifications');
    } finally {
      this.isRunning = false;
    }
  }

  async isSystemAlertsEnabled() {
    if (this.systemAlertsEnabled === null) {
      const systemProperties = await this.systemPropertyCache.toPromise();
      const systemAlertProperty = _.find(systemProperties, {code: 'SYSTEM_ALERTS_ENABLED'});
      this.systemAlertsEnabled = systemAlertProperty && systemAlertProperty.value === 'TRUE';
    }

    return this.systemAlertsEnabled;
  }

  getNotifications() {
    return this.redFlagAlertNotifications;
  }
};

module.service('redFlagAlertNotificationService', RedFlagAlertNotificationService);